/**
 * Logger utility for consistent logging across the application
 * - Development: all logs are output to console
 * - Production: only errors are output (or use a proper error tracking service)
 */

/* eslint-disable no-console */

const isDev = process.env.NODE_ENV === 'development'

/**
 * Logger object with methods for different log levels
 */
const logger = {
  /**
   * Debug level logging - only in development
   */
  log: (...args) => {
    if (isDev) {
      console.log(...args)
    }
  },

  /**
   * Info level logging - only in development
   */
  info: (...args) => {
    if (isDev) {
      console.info(...args)
    }
  },

  /**
   * Warning level logging - only in development
   */
  warn: (...args) => {
    if (isDev) {
      console.warn(...args)
    }
  },

  /**
   * Error level logging - always output (in both dev and production)
   * Consider integrating with an error tracking service in production
   */
  error: (...args) => {
    console.error(...args)
    // TODO: In production, send to error tracking service like Sentry
    // if (!isDev && window.Sentry) {
    //   window.Sentry.captureException(args[0])
    // }
  },

  /**
   * Debug level logging - alias for log, only in development
   */
  debug: (...args) => {
    if (isDev) {
      console.debug(...args)
    }
  }
}

export default logger
